import axios from "axios";
import { getToken } from "./auth";

export const baseURL = "https://fantasybets-backend.siglonet.com";
// export const baseURL = "http://localhost:8000";
export const API_KEY = "ba546ce68b75414b9dfd4323a9c02789";
// export const API_KEY = "0c56c689ee864363bb8cb1d176f289d0";

const api = axios.create({
  baseURL: baseURL + "/api",
});

api.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
